export const wrapperIdentifier = 'targetsAllianzUtils';
